import UserCard from "components/Shared/UserCard";
import sidebarLogo from "assets/logo_verify.svg";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { useAppSelector } from "redux/store";
import { Box, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import LanguageSwitcher from "components/LanguageSwitcher";

const Header = () => {

  const IMAGE_SERVER = process.env.REACT_APP_IMAGES_ENDPOINT;

  const { user } = useAppSelector((state) => state.userLoggedState);

  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{
        height: "6rem",
        backgroundColor: "#FFF",
        boxShadow: "0px 1px 15px 0px #0000000A",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Box
          sx={{
            padding: "0px 20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ width: "271px" }}>
            <img
              src={sidebarLogo}
              alt="Verify Logo"
              width="auto"
              height="90px"
            />
          </div>
        </Box>
        {user?.companyName&&(
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start", // Asegura que se alinee a la izquierda
              flexGrow: 1, // Empuja el resto de los elementos a la derecha
              paddingLeft: "20px", // Ajusta el margen izquierdo
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600, // Personaliza el estilo del texto
                color: "#333", // Cambia el color si es necesario
              }}
            >
              {user?.companyName}
            </Typography>
          </Box>
        )}
        <Toolbar style={{ gap: "20px" }}>
          <LanguageSwitcher/>
          {user && (
            <UserCard
              name={user?.name}
              lastName={user?.lastName}
              role={user?.role}
              imageUrl={
                user.image && `${IMAGE_SERVER}/${user.image}`
              }
            />
          )}
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default Header;
